import { ImmerGet, ImmerSet } from '../types';

import { EditableBotVersionSlice } from '@/domain/bot';
import { botVersionsAreDifferent } from 'utils/bot/state/editable-bot-fns';

/**
 * Creates undo/redo action handlers.
 */
export const createUndoRedoActions = (
    set: ImmerSet,
    get: ImmerGet,
): Pick<EditableBotVersionSlice, 'onUndo' | 'onRedo'> => ({
    onUndo: () => {
        set((state) => {
            if (get().itemsUndo.length == 0) {
                return;
            }

            let index = get().itemsUndo.length - 1;
            while (
                !botVersionsAreDifferent(
                    get().itemsUndo[index],
                    get().editingBot,
                ) &&
                index > 0
            ) {
                index -= 1;
            }

            const item = get().itemsUndo[index];
            state.itemsUndo.splice(
                index > 0 ? index : 1,
                state.itemsUndo.length,
            );
            state.itemsRedo.splice(0, 0, get().editingBot);
            state.editingBot = item;

            state.lastTimeUndoOrRedo = new Date().getTime();
        });
    },

    onRedo: () => {
        set((state) => {
            if (get().itemsRedo.length == 0) {
                return;
            }
            const item = get().itemsRedo[0];
            state.itemsRedo.splice(0, 1);
            state.itemsUndo.push(get().editingBot);
            state.editingBot = item;

            state.lastTimeUndoOrRedo = new Date().getTime();
        });
    },
});
